import { ReadFile } from '@paragon/client-tools';
import { HangerPrice, StandardConnectingHardwareModel } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAllHangerPrices() {
  return DesignService.get<readonly HangerPrice[]>('public/hangerPrices');
}

export function getMostRecentHangerPrice(hanger: StandardConnectingHardwareModel) {
  return DesignService.get<HangerPrice | null>(`public/hangerPrices/${hanger}/mostRecent`);
}

export function importHangerPrices(file: ReadFile) {
  return DesignService.post<readonly HangerPrice[]>('hangerPrices/importHangerPrices', { data: file });
}

export function exportHangerPrices() {
  return DesignService.fetchFile('hangerPrices/exportHangerPrices');
}

export interface NewHangerPrice {
  readonly hanger: StandardConnectingHardwareModel;
  readonly price: number;
  readonly notes: string | null;
}

export function postHangerPrice(newHangerPrice: NewHangerPrice) {
  return DesignService.post<HangerPrice>('public/hangerPrices', { data: newHangerPrice });
}

export interface HangerPriceEdit {
  readonly guid: string;
  readonly price: number;
  readonly notes: string | null;
}

export function putHangerPrices(edits: readonly HangerPriceEdit[]) {
  return DesignService.put<readonly HangerPrice[]>('public/hangerPrices/bulk', { data: edits });
}
